import { useContext, useState } from "react";
import { Header } from "../../components";
import {
    TransactionalSubheader,
    Button
} from "iuvity-ui-components";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/index";
import { Badge } from "iuvity-ui-components/dist/badge";
import { useForm } from "react-hook-form";
import { useProtocols } from "../../hooks/useProtocols";
import { DialogProps } from "../../components/dialog/CustomDialog";
import { CustomFormBox } from "../../components/points/CustomFormBox";
import { ProtocolsFormSchema } from "../../validations/schemas";
import { REVALIDATE_FORM_PROPS } from "../../constants";
import { useStatus } from '../../hooks/useStatus';
import { CustomDialog } from "../../components/dialog/CustomDialog";

interface NewProtocolsPageProps {
    update?: boolean;
    clone?: boolean;
}

// Inicializando los campos del formulario
const formBlankValues = {
    name: '',
    description: '',
}

export const NewProtocolsPage: React.FC<NewProtocolsPageProps> = ({
    update = false,
    clone = false,
}) => {
    const navigate = useNavigate();
    const {
        t,
        appState: { user, selectedProtocolsObject },
        setAppState,
    } = useContext(AppContext);

    // Tomando valores del context en caso de Editar
    const formValues = update ? {
        name: selectedProtocolsObject?.name,
        statusId: selectedProtocolsObject?.status?.id,
        description: selectedProtocolsObject?.description,
    } : clone
        ? {
            nametoclone: selectedProtocolsObject?.name,
            newname: '',
            description: selectedProtocolsObject?.description,
        } : {...formBlankValues}
    
    const form = useForm({
        mode: "onChange",
        delayError: 1200,
        reValidateMode: "onChange",
        // @ts-ignore
        defaultValues: formValues,
    });

    const {
        control,
        getValues,
        setValue,
        watch,
        resetField,
        formState: { errors, isDirty, isValid },
    } = form

    const protocolsFields = update ? [
        {
          key: "name",
          type: "text",
        },
        {
          key: "statusId",
          type: "dropdown",
        },
        {
            key: "description",
            type: "textarea",
        },
    ] : clone ? [
        {
            key: "nametoclone",
            type: "text",
          },
          {
              key: "description",
              type: "textarea",
          },
          {
            key: "newname",
            type: "text",
          },
        ] : [
                {
                key: "name",
                type: "text",
                },
                {
                    key: "description",
                    type: "textarea",
                },
            ]

    const { data: dataStatus } = useStatus(update ? "DATA" : "ACTIONS");
    const { protocolsAction } = useProtocols("ACTIONS");
    const [modalProps, setModalProps] = useState<DialogProps>({
        visible: false,
    } as DialogProps);
    const formKeysOptions:any = {
        statusId: dataStatus?.map((item: any)=>({
            label: ['ACTIVE', 'INACTIVE', 'DRAFT', 'DELETED'].includes(item?.name) ? t(`Catalogue.${item?.name}Label`) : item?.name,
            value: item?.id,
        }))
        .sort((a: any, b: any) => a.label.localeCompare(b.label)),
    };

    const onReturn = () => {
        setAppState((prev) => ({
        ...prev,
        selectedPointsObject: null,
        activeIndexPoints: 0,
        }));
        navigate('/catalogue');
        window.scrollTo(0, 0);
    };

    const onAction = async () => {
        let formValues = getValues();
        if (clone) formValues = {
            name: formValues.newname,
            description: formValues.description,
            nametoclone: undefined,
            statusId: undefined,
        };
        const actionResult = await protocolsAction(update ? "UPDATE" : "CREATE",
        update ? {...formValues, id: selectedProtocolsObject.id} : formValues);
        if (actionResult === "SUCCESS") {
        setAppState((prev) => ({
            ...prev,
            activeIndexPoints: 0,
        }));
        navigate("/catalogue");
        window.scrollTo(0, 0);
        }
    };

    const handleModalProps = (actionType: "action" | "cancel", goHome?: boolean) => {
        switch (actionType) {
        case "action":
            return setModalProps((prev) => ({
            ...prev,
            visible: true,
            title: t(`Catalogue.createModalTitle`),
            content: t(`Catalogue.${update ? "save" : "create"}ProtocolsModalContent`),
            onConfirm: onAction,
            }));
        case "cancel":
            return setModalProps((prev) => ({
            ...prev,
            visible: true,
            title: t("Catalogue.cancelModalTitle"),
            content: t("Catalogue.cancelModalContent"),
            onConfirm: goHome ? () => navigate('/') : onReturn,
            }));
        default:
            return;
        }
    };

    return (
        <>
            {/* <Header
                welcomeMessage={t("Dashboard.welcomeTitle")}
                userName={user?.name}
            /> */}

            <TransactionalSubheader
                subheaderTitle={
                <div style={{ position: "relative", left: "-40px" }}>
                    <div className="flex flex-row align-items-center">
                    <i
                        className="iu iu-icon-left pr-3"
                        onClick={() => isDirty ? handleModalProps("cancel") : onReturn()}
                        aria-hidden="true"
                        style={{
                        fontSize: "var(--font-size-tablet-title)",
                        cursor: "pointer",
                        }}
                    />
                    <div className="flex alig-items-center" style={{ color: "var(--cardBackgroundColorOneShade80)" }}>
                        {
                            update
                            ? t("Catalogue.editTitle")
                            : clone
                                ? t("Catalogue.cloneTitle")
                                : t("Catalogue.createTitle")
                        }
                        <Badge
                            className={'flow-badge ml-3'}
                            value={t('Catalogue.protocolsTabTitle')}
                            style={{
                                textTransform: "capitalize",
                                color: "var(--cardBackgroundColorOneShade80)",
                            }}
                        />
                    </div>
                    </div>
                </div>
                }
            >
            <TransactionalSubheader.BreadCrumb
                id={t(`Catalogue.${update ? 'edit' : clone ? 'clone' : 'create'}ProtocolsTitle`)}
                disabledDefaultHome={true}
                breadcrumbsHomeItem={{
                    icon: "iu iu-icon-home",
                    command: () => isDirty ? handleModalProps("cancel", true) : navigate('/'),
                }}
                breadcrumbsItems={[
                    {
                        label: t("Catalogue.consoleManagementBreadcrumbs"),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                    {
                        label: t("Catalogue.rolesManagementBreadcrumbs"),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                    {
                        label: t("Catalogue.catalogueTitle"),
                        style: { fontFamily: "var(--fontBarlowSemiBold)" },
                        command: () => isDirty ? handleModalProps("cancel") : onReturn(),
                    },
                    {
                        label: t(`Catalogue.${update ? 'edit' : clone ? 'clone' : 'create'}ProtocolsBreadcrumbs`),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                ]}
                />
                <TransactionalSubheader.Title />
            </TransactionalSubheader>

            {/* Descripción de la página */}
            <p
                className="action-page-description"
                style={{
                    paddingTop: 'var(--padding-level-thirty-two)',
                    margin: '0 128px',
                }}
            >
                {t(`Catalogue.${update ? 'edit' : clone ? 'clone' : 'create'}ProtocolsDescription`)}
            </p>

            {/* Caja de Información Básica */}
            <div className={`custom-form-box__protocols-actions${clone ? '-clone' : ''}`}>
                <CustomFormBox
                    fields= {protocolsFields}
                    form= {form}
                    dropdownOptions={formKeysOptions}
                    schemaOfValidation={ProtocolsFormSchema}
                    REVALIDATE_FORM_PROPS={REVALIDATE_FORM_PROPS}
                    labelFunctionality="Catalogue"
                    readOnlyObject={{nametoclone: clone ? true : false,}}
                    dropdownShowClearObject={{status: true}}
                />
            </div>

            {/* Buttons */}
            <div className="catalogue-newprotocols-buttons">
                <div
                    className="ap-selector-btn-c my-5 gap-5"
                    style={{ marginRight: "128px" }}
                >
                    <Button
                        variant="p-button-link"
                        label={t("Products.cancelBtnLabel")}
                        onClick={
                        update
                        ? 
                            !isDirty 
                            ? onReturn
                            : () => handleModalProps("cancel")
                        :
                            !isDirty ? onReturn : () => handleModalProps("cancel")}
                    />
                    <Button
                        variant="p-button"
                        label={t(`Catalogue.${update ? 'save' : clone ? 'clone' : 'create'}BtnLabel`)}
                        disabled={
                            update
                                ? !(isDirty && isValid)
                                : !isValid
                        }
                        onClick={() => handleModalProps("action")}
                    />
                </div>
            </div>
            <CustomDialog
                title={modalProps.title}
                visible={modalProps.visible}
                content={modalProps.content}
                handleModalState={setModalProps}
                onConfirm={modalProps.onConfirm}
            />
        </>
    )
}